import type { DocMigration } from "../docMigration";
import { forEachRoomNoBlockLayout } from "../docMigrationUtils";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_41a: DocMigration = {
  description:
    "(Intentionally skips two versions as there was a mistake in the first impl) Inverts, adds new annotation fields, changes interiorDimensions to interiorAutoDimensions",
  maxSchemaVersion: "0.0.41",
  apply(json: any) {
    if (json.viewerFilter) {
      const viewerFilter = json.viewerFilter;

      if (!viewerFilter.hasOwnProperty("interiorAutoDimensions")) {
        viewerFilter.interiorAutoDimensions = viewerFilter.interiorDimensions;
        delete viewerFilter.interiorDimensions;

        for (const id in viewerFilter) {
          viewerFilter[id] = !viewerFilter[id];
        }
      }

      if (!viewerFilter.hasOwnProperty("annotation")) {
        viewerFilter["annotation"] = true;
        viewerFilter["annotationFloorPlan"] = true;
        viewerFilter["annotationElectricalPlan"] = true;
        viewerFilter["annotationFoundationPlan"] = true;
        viewerFilter["annotationPlumbingPlan"] = true;
        viewerFilter["annotationMechanicalPlan"] = true;
        viewerFilter["annotationRoofPlan"] = true;
      }
    }

    forEachRoomNoBlockLayout(json, (room) => {
      if (room?.layout?.linework) {
        if (!room.layout.annotation) {
          room.layout.annotation = [];
        }
        room.layout.annotation.push(...room.layout.linework);
        delete room.layout.linework;
      }
    });

    if (json.locked) {
      for (const elementId in json.locked) {
        const element = json.locked[elementId];
        if (element.type === "LINEWORK") {
          element.type = "ANNOTATION";
        }
      }
    }

    if (json.hidden) {
      for (const elementId in json.hidden) {
        const element = json.hidden[elementId];
        if (element.type === "LINEWORK") {
          element.type = "ANNOTATION";
        }
      }
    }

    return json;
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_41: DocMigration = {
  description: "Adds a sortIndex property to blocks",
  maxSchemaVersion: "0.0.41",
  apply(json: any, warnings: string[], errors: string[]) {
    json = migration_0_0_41a.apply(json, warnings, errors);

    Object.keys(json.blocks)
      .sort((b1, b2) => {
        return json.blocks[b1].levelId - json.blocks[b2].levelId;
      })
      .forEach((key, index) => {
        json.blocks[key].sortIndex = index;
      });

    return json;
  },
};

export default migration_0_0_41;
